import React from 'react';

export const RedirectWindowContext = React.createContext();
